import type { ProjectSupplier } from "../entities";

/**
 * Result of transforming suppliers for form usage
 */
export interface TransformedSuppliers {
  /** Array of supplier names for display in autocomplete */
  names: string[];
  /** Map for looking up supplier ID by name during form submission */
  nameToIdMap: Map<string, string>;
}

/**
 * Transforms supplier/group data for use in form components
 *
 * Converts array of suppliers (from project role endpoint) to:
 * 1. Array of names for autocomplete display
 * 2. Map for name→id lookup during form submission
 *
 * @param suppliers - Array of suppliers from /api/projects/{projectId}/withRole/supplier
 * @returns Object with names array and nameToIdMap
 */
export function transformSuppliers(suppliers: ProjectSupplier[] | null): TransformedSuppliers {
  if (!suppliers || suppliers.length === 0) {
    return {
      names: [],
      nameToIdMap: new Map(),
    };
  }

  const names: string[] = [];
  const nameToIdMap = new Map<string, string>();

  for (const supplier of suppliers) {
    names.push(supplier.name);
    nameToIdMap.set(supplier.name, supplier.id);
  }

  return {
    names,
    nameToIdMap,
  };
}
